import type { Task } from "@app/core";

import { useTasksStore } from "../../stores/index.js";
import { useMatrixPriorityColor } from "../priority-matrix/useEffectiveMatrixDisplay.js";
import { effectiveColorOf } from "../task-colors.js";
import { useTaskContextColor } from "../useTaskContextColor.js";

/** Neutral slate used when a task resolves to no color at all, so agenda
 *  surfaces always have a concrete accent to paint. */
export const ACCENT_FALLBACK = "#94a3b8";

/**
 * The single accent hex an agenda surface paints for a task: its effective
 * render color (custom → inherited subtask tint → matrix diagonal / priority →
 * theme context → event slate), same resolution the calendar uses, with a
 * muted slate fallback so no row is ever bare.
 */
export function useTaskAccent(task: Task): string {
  const tasks = useTasksStore((s) => s.tasks);
  const contextColor = useTaskContextColor(task);
  const matrixColor = useMatrixPriorityColor(task);
  return effectiveColorOf(task, tasks, 0, contextColor, matrixColor) ?? ACCENT_FALLBACK;
}
